/* eslint-disable require-jsdoc */
/* eslint-disable valid-jsdoc */
/**
 * Hack to turn off or on live region on hero-carousel
 */
export default function updateHeroCarouselLiveRegion(enabled = true) {
    const nodes = document.querySelectorAll('.hero-carousel-aria-live');
    nodes.forEach((node) => {
        node.ariaLive = enabled ? 'polite' : 'off';
    });
}

export function enableHeroCarouselLiveRegion() {
    updateHeroCarouselLiveRegion(true);
}

export function disableHeroCarouselLiveRegion() {
    updateHeroCarouselLiveRegion(false);
}
